/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersnotelabel2Inputs */

const en_partnersnotelabel2 = /** @type {(inputs: Partnersnotelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note (optional)`)
};

const de_partnersnotelabel2 = /** @type {(inputs: Partnersnotelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notiz (optional)`)
};

/**
* | output |
* | --- |
* | "Note (optional)" |
*
* @param {Partnersnotelabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersnotelabel2 = /** @type {((inputs?: Partnersnotelabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersnotelabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersnotelabel2(inputs)
	return de_partnersnotelabel2(inputs)
});
export { partnersnotelabel2 as "partnersNoteLabel" }